import { render, staticRenderFns } from "./PurchaseByVendor.vue?vue&type=template&id=48d7dbe3"
import script from "./PurchaseByVendor.vue?vue&type=script&lang=js"
export * from "./PurchaseByVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports